import { TextField } from "@mui/material";
import { styled } from "@mui/system";
import GlobalTheme from "../../../styles/global.theme";

export const VerificationTextfield = styled(TextField)(({ theme }) => ({
    width: "40px",
    height: "50px",
    fontSize: "20px",
    fontWeight: "600",
    textAlign: "center",
    borderRadius: "4px",
    color: `${GlobalTheme.palette.black.primary.main}`,
    backgroundColor: `${GlobalTheme.palette.white.primary.main}`,

    "& .MuiInputBase-root": {
        height: "100%",
        color: `${GlobalTheme.palette.black.primary.main}`,
    },

    "& .MuiInputBase-input": {
        textAlign: "center",
        fontSize: "20px",
        fontWeight: "600",
        color: `${GlobalTheme.palette.black.primary.main}`,
    },
    "& .MuiInputLabel-root.Mui-focused": {
        color: `${GlobalTheme.palette.grey.primary.main}!important`,
        backgroundColor: `${GlobalTheme.palette.white.primary.main}`,
    },
    // Remove colorPrimary from the outlined input border
    "& .MuiOutlinedInput-root": {
        "&:hover fieldset": {
            borderColor: `${GlobalTheme.palette.grey.primary.darker}`,
        },
        "&.Mui-focused fieldset": {
            borderColor: `${GlobalTheme.palette.grey.primary.darker}`,
        },
        "& fieldset": {
            borderColor: `${GlobalTheme.palette.grey.primary.darker}`,
        },
    },
    [theme.breakpoints.up("md")]: {
        width: "50px",
        height: "50px",
        fontSize: "20px",
    },
    [theme.breakpoints.up("lg")]: {
        width: "60px",
        height: "60px",
        fontSize: "20px",
    },
}));

export const CustomTextField = styled(TextField)(({ error }) => ({
    width: "100%",
    borderRadius: "8px",
    "& .MuiInputLabel-root": {
        color: `${GlobalTheme.palette.black.primary.main}`,
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "28px",
        fontfamily: `${GlobalTheme.typography.fontFamily}`,
        padding: "0 7px 0 5px",
        "&.Mui-focused, &:hover, &:active": {
            color: error
                ? `${GlobalTheme.palette.pink.primary.main}`
                : `${GlobalTheme.palette.black.primary.main} `,
            backgroundColor: `${GlobalTheme.palette.white.primary.main}`,
            padding: "0 7px 0 5px",
            fontSize: "20px",
        },
        "&.MuiFormLabel-filled": {
            color: `${GlobalTheme.palette.black.primary.main}`,
            backgroundColor: `${GlobalTheme.palette.white.primary.main}`,
            padding: "0 7px 0 5px",
            fontSize: "20px",
        },
        "&.Mui-disabled": {
            color: `${GlobalTheme.palette.grey.primary.darker}`,
        },
    },

    "& .MuiOutlinedInput-root": {
        paddingLeft: "10px",
        paddingRight: 0,
        "& fieldset": {
            borderColor: error
                ? `${GlobalTheme.palette.pink.primary.main}`
                : `${GlobalTheme.palette.grey.primary.darker} `,
            border: `1px solid ${GlobalTheme.palette.grey.primary.secondary}`,
            borderRadius: "8px",
        },
        "&:hover fieldset": {
            borderColor: error
                ? `${GlobalTheme.palette.pink.primary.main}`
                : `${GlobalTheme.palette.grey.primary.darker} `,
        },
        "&.Mui-focused fieldset": {
            borderColor: error
                ? `${GlobalTheme.palette.pink.primary.main}`
                : `${GlobalTheme.palette.grey.primary.darker} `,
            border: `2px solid ${GlobalTheme.palette.grey.primary.secondary}`,
        },
    },
    "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
        borderColor: `${GlobalTheme.palette.grey.primary.main}`,
    },
    "&.Mui-focused .MuiSvgIcon-root ": {
        fill: `${GlobalTheme.palette.grey.primary.darker}! `,
    },
    "& input:-webkit-autofill": {
        WebkitTextFillColor: `${GlobalTheme.palette.black.primary.main}! `,
    },
    // "& .MuiFormHelperText-root": {
    //   color: error
    //   ? `${GlobalTheme.palette.pink.primary.main}`
    //   : `${GlobalTheme.palette.black.primary.main} `,
    //   fontSize: "16px",
    //   height: "auto",
    //   wordWrap: "break-word",
    //   lineHeight: "18px",
    //   paddingTop: "5px",
    // },
}));

export const CopyLinkTextfield = styled(TextField)({
    flex: 1,
    fontSize: "18px",
    height: "58px",
    width: "100%",
    backgroundColor: `${GlobalTheme.palette.white.primary.main}`,
    borderRadius: "0px 0 0 4px",
    "& .MuiFormLabel-root": {
        color: `${GlobalTheme.palette.black.primary.main}`,
        fontSize: "20px",
        fontWeight: "400",
        zIndex: 1,
        backgroundColor: `${GlobalTheme.palette.white.primary.main}`,
        padding: "0 8px",
    },

    "& .MuiFormLabel-root.Mui-focused": {
        color: `${GlobalTheme.palette.black.primary.main} !important`,
        transform: "translate(14px, -6px) scale(0.75)",
    },

    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: `${GlobalTheme.palette.grey.primary.darker}!important`,
    },
    "& .MuiInputBase-input": {
        paddingLeft: "10px",
        paddingRight: "50px",
        lineHeight: "24px",
        "& .MuiOutlinedInput-root": {
            height: "48px",
            paddingRight: "30px",
            paddingLeft: "10px",
            position: "relative",
        },
        "@media (max-width: 600px)": {
            "& .MuiOutlinedInput-root": {
                paddingLeft: "10px",
            },
        },
        "@media (max-width: 320px)": {
            "& .MuiOutlinedInput-root": {
                paddingRight: "45px",
                paddingLeft: "10px",
                fontSize: "14px",
                width: "80%",
            },
        },
    },
});

export const CustomPaymentTextField = styled(TextField)(({ error }) => ({
    "& .MuiInputBase-root": {
        fontSize: 16,
    },
    "&::placeholder": {
        fontWeight: "bold",
        fontSize: 16,
    },
    marginBottom: "12px",
    "& .MuiInputLabel-root": {
        color: `${GlobalTheme.palette.black.primary.main}`,
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "28px",
        fontFamily: `${GlobalTheme.typography.fontFamily}`,
        padding: "0 7px 0 5px",

        "&.Mui-focused, &:hover, &:active": {
            color: error
                ? `${GlobalTheme.palette.pink.primary.main}`
                : `${GlobalTheme.palette.black.primary.main} `,
            backgroundColor: `${GlobalTheme.palette.white.primary.main}`,
            padding: "0 7px 0 5px",
            fontSize: "20px",
        },
        "&.MuiFormLabel-filled": {
            color: `${GlobalTheme.palette.black.primary.main}`,
            backgroundColor: `${GlobalTheme.palette.white.primary.main}`,
            padding: "0 7px 0 5px",
            fontSize: "20px",
        },
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: `1.5px solid ${GlobalTheme.palette.grey.primary.main}`,
            borderRadius: "6px",
        },
        "&:hover fieldset": {
            borderColor: error
                ? `${GlobalTheme.palette.pink.primary.main}`
                : `${GlobalTheme.palette.grey.primary.darker} `,
        },
        "&.Mui-focused fieldset": {
            borderColor: error
                ? `${GlobalTheme.palette.pink.primary.main}`
                : `${GlobalTheme.palette.grey.primary.darker} `,
        },
    },

    "&.Mui-focused .MuiSvgIcon-root ": {
        fill: `${GlobalTheme.palette.purple.primary.darker} !important`,
    },

    "& input:-webkit-autofill": {
        WebkitBoxShadow: `0 0 0 1000px ${GlobalTheme.palette.white.primary.main}`,
        WebkitTextFillColor: `${GlobalTheme.palette.black.primary.main}`,
    },

    "& .MuiFormHelperText-root": {
        color: error
            ? `${GlobalTheme.palette.pink.primary.main}`
            : `${GlobalTheme.palette.black.primary.main}`,
        fontSize: "14px",
        fontWeight: "500",
    },
}));
